import type { CashListSelectorRules } from './filterCashListsForSelector';

export const receiptCashLinkAddRules: CashListSelectorRules = {
  requireFlags: ['manualWithdrawalOther', 'manualReceiptLinking'],
  excludeConfigIds: ['pliantReferenceCashListId'],
};

export const receiptCashLinkSelectRulesDefault: CashListSelectorRules = {
  requireFlags: ['manualReceiptLinking'],
};

export const receiptCashLinkSelectRulesWithPliantHidden: CashListSelectorRules =
  {
    requireFlags: ['manualReceiptLinking'],
    excludeConfigIds: ['pliantReferenceCashListId'],
  };

export const settlementCashLinkSelectRules: CashListSelectorRules = {
  requireFlags: ['manualReceiptLinking'],
  excludeConfigIds: ['pliantReferenceCashListId'],
};

export const settlementCashLinkAddRules: CashListSelectorRules = {
  requireFlags: ['manualDepositOther', 'manualReceiptLinking'],
  excludeConfigIds: ['pliantReferenceCashListId'],
};

export const residentPayinRules: CashListSelectorRules = {
  requireFlags: ['manualDepositPayin'],
  onlyConfigIds: ['nursingHomeCashCashListId', 'payinTargetCashListId'],
};

export const residentPayoutRules: CashListSelectorRules = {
  requireFlags: ['manualWithdrawalOther', 'manualReceiptLinking'],
  excludeConfigIds: ['pliantReferenceCashListId'],
};

export const receiptBatchCashLinkAddRules: CashListSelectorRules = {
  requireFlags: ['manualWithdrawalOther', 'manualReceiptLinking'],
  excludeConfigIds: ['pliantReferenceCashListId'],
};
